import { render } from "./EnbPainel.vue?vue&type=template&id=60dfa932&scoped=true"
import script from "./EnbPainel.vue?vue&type=script&lang=js"
export * from "./EnbPainel.vue?vue&type=script&lang=js"

import "./EnbPainel.vue?vue&type=style&index=0&id=60dfa932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dfa932"]])

export default __exports__